import type { IFilter } from '@models/Filter'
import type { Query } from '@models/Query'

import { apiClient } from '../../../gateways/api'
import type { FetchKpi, FetchKpiFilters } from '../types/FetchKpi'

export { fetchKpi, createFilters, initialState }

const fetchKpi = async ({
  query,
}: {
  query: Query<FetchKpiFilters>
}): Promise<FetchKpi['data']> => {
  const { filters } = query

  const { data } = await apiClient({
    url: '/rest/dashboard/hoofdleiding/kpi',
    method: 'POST',
    data: { filters: createFilters(filters) },
  })

  return data
}

const createFilters = ({
  gebied,
  labels,
  verantwoordelijke,
  contactpersoon,
  myList,
  opleverweekVan,
  opleverweekTot,
  netbeheerder,
  typeWerk,
}: Partial<FetchKpiFilters>) => {
  const filters: IFilter[] = []

  if (gebied && gebied.length > 0)
    filters.push({
      name: 'gebiedscode',
      value: gebied.map(({ code }) => code),
      operator: 'in',
    })

  if (labels && labels.length > 0)
    filters.push({
      name: 'labels',
      value: labels.map(({ code }) => code),
      operator: 'in',
    })

  if (verantwoordelijke)
    filters.push({
      name: 'verantwoordelijken',
      value: verantwoordelijke.code,
      operator: 'eq',
    })

  if (contactpersoon)
    filters.push({
      name: 'contactpersoon',
      operator: 'eq',
      value: contactpersoon.userid,
    })

  if (myList) {
    filters.push({ name: 'my-list', value: true, operator: 'eq' })
  }

  if (opleverweekVan) {
    filters.push({
      name: 'dueWeek',
      value: opleverweekVan,
      operator: 'gte',
    })
  }

  if (opleverweekTot) {
    filters.push({
      name: 'dueWeek',
      value: opleverweekTot,
      operator: 'lte',
    })
  }

  if (netbeheerder)
    filters.push({ name: 'netbeheerders', value: netbeheerder, operator: 'eq' })

  if (Array.isArray(typeWerk) && typeWerk.length > 0) {
    filters.push({
      name: 'typeWerk',
      operator: 'in',
      value: typeWerk,
    })
  }

  return filters
}

const initialState: FetchKpi = {
  data: [],
  query: {
    filters: {
      gebied: [],
      labels: [],
      myList: false,
      verantwoordelijke: null,
      contactpersoon: null,
      opleverweekTot: '',
      opleverweekVan: '',
      netbeheerder: null,
      typeWerk: [],
    },
  },
}
